// extracted by mini-css-extract-plugin
export default {"chats_list":"ChatList_chats_list__6iQaw"};